<template>
  <span
    @click="$emit('click')"
    :class="[
      iconClass,
      `icon-container--${variant}`,
      `icon-container--${size}`,
      {
        'mr-1': marginRight,
        'cursor-pointer': clickable,
      },
    ]"
  >
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    clickable: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'circle',
    },
    size: {
      type: String,
      default: 'sm',
    },
    iconClass: {
      type: String,
      default: 'text-secondary-50 bg-secondary-15',
    },
    marginRight: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss">
.icon-container--circle {
  @apply w-5 h-5 rounded-full align-middle;
  @apply inline-flex justify-center items-center;
}

.icon-container--square {
  @apply w-20 h-10 rounded align-middle;
  @apply inline-flex justify-center items-center;
}

.icon-container--sm {
  @apply w-5 h-5;
}

.icon-container--md {
  @apply w-6 h-6;
}

.icon-container--lg {
  @apply w-10 h-10;
}
</style>
